import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { api } from '../../lib/supabase';
import { useApi } from '../../lib/use-api';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function MobileReady() {
  const { id } = useParams();
  const nav = useNavigate();
  const { data: event } = useApi(api.getEvent, [id]);
  const { data: participation } = useApi(api.getMyParticipation, [id]);
  const [busy, setBusy] = useState(false);

  async function handleReady() {
    setBusy(true);
    try {
      await api.markReady(id);
      nav(`/events/${id}/race`);
    } catch (err) {
      toast.error(err.message || 'Failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="px-4 pt-4 pb-6 min-h-full flex flex-col" data-testid="ready-screen">
      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-6">
        <div className="h-20 w-20 rounded-md bg-success/10 text-success flex items-center justify-center">
          <CheckCircle2 className="h-10 w-10" />
        </div>
        <div>
          <p className="rivl-label">Checked in</p>
          <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Awaiting official start</h1>
          <p className="text-sm text-muted-foreground mt-2 max-w-xs mx-auto">
            Remain within the start zone. The race will begin when the organizer triggers the start.
          </p>
        </div>
        <div className="rivl-card p-4 w-full max-w-xs">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Event</span>
            <span className="font-medium">{event?.name || '—'}</span>
          </div>
          <div className="flex justify-between text-sm mt-2">
            <span className="text-muted-foreground">Bib</span>
            <span className="font-mono font-bold">#{participation?.bibNumber || '—'}</span>
          </div>
          <div className="flex justify-between text-sm mt-2">
            <span className="text-muted-foreground">Status</span>
            <span className="font-mono text-xs">{participation?.state?.toUpperCase() || '—'}</span>
          </div>
        </div>
      </div>
      <Button onClick={handleReady} disabled={busy} className="w-full h-12 rounded-md mt-6" data-testid="ready-go-live">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "I'm ready · Enter race mode"}
      </Button>
    </div>
  );
}
